import type {ValueVisualDescriptorList} from '@github-ui/filter-core'
import type {Icon} from '@primer/octicons-react'

type ResolvedValueVisual =
  | {
      kind: 'avatar'
      url: string
      alt: string
      square?: boolean
    }
  | {
      kind: 'color-swatch'
      color: string
    }
  | {
      kind: 'octicon'
      icon: Icon
      color?: string
    }

const normalizeVisuals = (visuals?: ValueVisualDescriptorList | null) => {
  if (!visuals) return []
  return Array.isArray(visuals) ? visuals : [visuals]
}

export const resolveValueVisualDescriptor = (
  visuals?: ValueVisualDescriptorList | null,
  providerIcon?: Icon,
): ResolvedValueVisual | null => {
  for (const visual of normalizeVisuals(visuals)) {
    switch (visual.kind) {
      case 'avatar':
        if (visual.url) {
          return {
            kind: 'avatar',
            url: visual.url,
            alt: visual.alt ?? 'User Avatar',
            square: visual.square,
          }
        }
        break
      case 'color-swatch':
        if (visual.color) {
          return {kind: 'color-swatch', color: visual.color}
        }
        break
      case 'octicon':
        if (visual.icon) {
          return {kind: 'octicon', icon: visual.icon, color: visual.color}
        }
        break
      case 'provider-icon': {
        const icon = visual.icon ?? providerIcon
        if (icon) {
          return {kind: 'octicon', icon}
        }
        break
      }
      default:
        break
    }
  }

  return null
}

export type {ResolvedValueVisual}
